import React from 'react';
import { Skeleton, SkeletonSquare } from '@fiverr-private/feedback';
import { Box } from '@fiverr-private/theme';
import { getContext } from '@fiverr-private/fiverr_context';
import { TABBED_CAROUSELS_HEIGHT } from './constants';

const TabbedCarouselsSkeleton = (): JSX.Element => {
    const { isMobile } = getContext();
    const skeletonHeight = isMobile ? TABBED_CAROUSELS_HEIGHT.MOBILE : TABBED_CAROUSELS_HEIGHT.DESKTOP;

    return (
        <Skeleton width="auto" dataTestId="tabbed-carousels-skeleton">
            <Box minHeight={skeletonHeight}>
                <SkeletonSquare height={skeletonHeight} />
            </Box>
        </Skeleton>
    );
};

export default TabbedCarouselsSkeleton;
